export default __webpack_public_path__ + "static/media/bg2.a9c269db.jpg";